import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {DPBlockedDomain} from '../shared/domain/bd/dp-blocked-domain.model';
import {Page} from '../shared/domain/page.model';

@Injectable()
export class DpStatsBlockedDomainsService {

  constructor(private http: HttpClient) {
  }

  blockedDomainsMailed(page, size, domain): Observable<Page<DPBlockedDomain>> {
    return this.http.get<Page<DPBlockedDomain>>(`${environment.serviceUrl}/ad-stats/dp-stats/blocked-domains/mailed?page=${page}&size=${size}&domain=${domain}`);
  }

  blockedDomainsMailedExport(domain = '') {
    return this.http.get(`${environment.serviceUrl}/ad-stats/dp-stats/blocked-domains/mailed/export?domain=${domain}`, {
      responseType: 'text'
    });
  }

  blockedDomains(page, size, domain): Observable<Page<DPBlockedDomain>> {
    return this.http.get<Page<DPBlockedDomain>>(`${environment.serviceUrl}/ad-stats/dp-stats/blocked-domains?page=${page}&size=${size}&domain=${domain}`);
  }

  blockedDomainsUpdate(data: DPBlockedDomain[]): Observable<DPBlockedDomain[]> {
    return this.http.put<DPBlockedDomain[]>(`${environment.serviceUrl}/ad-stats/dp-stats/blocked-domains`, data);
  }
}
